module.exports = __webpack_public_path__ + "static/media/maid.159beded.svg";